import { FormControlLabel, useRadioGroup } from "@mui/material";

function CustomRadioGroupLabel(props) {
  const radioGroup = useRadioGroup();
  let checked = false;
  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }
  return <FormControlLabel checked={checked} {...props} />;
}

export default CustomRadioGroupLabel;
